import React from 'react';
import { Twitter, Linkedin, Github, Instagram } from 'lucide-react';

const SocialFollow: React.FC = () => {
  return (
    <div className="bg-gradient-to-br from-violet-600 to-blue-600 rounded-2xl p-8">
      <h3 className="text-2xl font-bold mb-4">Follow Us</h3>
      <p className="mb-6 opacity-90 leading-relaxed">
        Stay connected with kol.my on social media for the latest updates, 
        success stories, and influencer marketing insights.
      </p>
      <div className="flex space-x-4">
        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white/30 transition">
          <Instagram className="w-5 h-5" />
        </div>
        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white/30 transition">
          <Linkedin className="w-5 h-5" />
        </div>
        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white/30 transition">
          <Twitter className="w-5 h-5" />
        </div>
        <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center hover:bg-white/30 transition">
          <Github className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};

export default SocialFollow;
